import type { SYSAction } from "../../../../../../../_ovlclient/src"
import { html, ovl } from "../../../../../../../_ovlclient/src/"
import { Data } from "../../../../../../../_ovlclient/src/dataapi"
import {
  FeatureInfo,
  FileGet,
} from "../../../../../../../_ovlclient/src/global/globalapi"
import type {
  HookFieldGetEditHint_ReturnType,
  HookFieldGetEditHint_Type,
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFieldGetValueRender_ReturnType,
  HookFieldGetValueRender_Type,
  HookFormInit_ReturnType,
  HookFormInit_Type,
  HookTableAfterDelete_Type,
  HookTableAfterSave_Type,
  HookTableDragDrop_Type,
  HookTableRowFnCan_Type,
  HookTableRowFn_Type,
  HookTableSetColumnVisibility_Type,
  HookViewRowClass_ReturnType,
  HookViewRowClass_Type,
} from "../../../../../../../_ovlclient/src/global/hooks"
import { DialogOkCancel } from "../../../../../../../_ovlclient/src/library/dialog/dialogapi"
// <AssetConfig Import/Export>
// import template function for asset config
// always do import export this style because else we will run into an strict error

import {
  FieldIsValid,
  FieldVal,
} from "../../../../../../../_ovlclient/src/library/forms/fieldapi"
import {
  ProcessEnd,
  ProcessIsRunning,
  ProcessStart,
} from "../../../../../../../_ovlclient/src/library/longrunningprocesstracker/processapi"
import {
  ScreenCurrent,
  ScreenNavigateTo,
} from "../../../../../../../_ovlclient/src/library/screenapi"
import {
  TableRebuild,
  TableSaveRow,
} from "../../../../../../../_ovlclient/src/library/table/tableapi"
import { D, N0, T } from "../../../../../../../_ovlclient/src/textapi"
import { ResetDetailChanges } from "../../../screens/qutoffering/offering/details/helpers"
import {
  BrowseOfferFile,
  EditLocked,
  GetDeliveryTimeHint,
  OfferingStatus,
  OpenTableUploadEdit,
} from "../../../screens/qutoffering/offering/helpers"
import { hooks as OfferAdminUploadHooks } from "./adminupload/hookactions"
import { Offering } from "./tabledef"
const HookField_U_ITF_PRT_OfferType_GetList =
  OfferAdminUploadHooks.HookField_OfferType_GetList

const HookTableAfterSave: SYSAction<HookTableAfterSave_Type> = async (
  value
) => {
  if (value.returnedKeys.get(value.key)?.columns["U_ITF_PRT_OfferType"]) {
    TableRebuild("QUTOffering")
    TableRebuild("QUTOfferingActual")
  }
}

const HookTableDragDrop: SYSAction<HookTableDragDrop_Type> = (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  switch (value.type) {
    case "dragstart":
      let target: any = value.e.target
      //@ts-ignore
      if (target?.row?.key) {
        value.e.dataTransfer.setData("plain/text", target?.row?.key)
        value.e.dataTransfer.effectAllowed = "link"
      }
      break
  }
}

const HookTableSetColumnVisibility: SYSAction<
  HookTableSetColumnVisibility_Type<Offering>
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  value.def.columns.CntctName.ui.visibility =
    value.screen === "QUTOffering" ? "None" : "Table"
}

const HookFormInit: SYSAction<HookFormInit_Type, HookFormInit_ReturnType> = (
  { formState },
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  let res: HookFormInit_ReturnType
  switch (ScreenCurrent()) {
    case "QUTOfferingDetails":
      formState.forceFocusWhenVisibleFieldKey = "U_COR_LI_1"
  }

  let weekState = state.app.features.QUTOffering.lookups.WeekAndDate
  let currentField = formState.fields["U_COR_LI_1"]
  let currentVal = FieldVal(currentField)
  if (currentVal && !weekState.data[currentVal]) {
    weekState.data[currentVal] = {
      MidDate: currentVal,
      WeekNr: `~${D(currentVal)}`,
    }
  }
  res = { fieldsToRemove: [] }
  if (!FeatureInfo("QUTOfferingToolAdmin")) {
    res.fieldsToRemove.push(
      formState.fields["U_ITF_PRT_OfferByAdmin" as keyof Offering].fieldKey
    )
    res.fieldsToRemove.push(
      formState.fields["U_ITF_PRT_OfferType" as keyof Offering].fieldKey
    )
  }

  if (state.app.features.QUTOffering.offerMainType === "CUT") {
    res.fieldsToRemove.push(
      formState.fields["U_ITF_PRT_OfferType" as keyof Offering].fieldKey
    )
  }

  return res
}

const HookField_U_COR_LI_1_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let weekState = state.app.features.QUTOffering.lookups.WeekAndDate
  return weekState
}

const HookField_U_COR_LI_1_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  return GetDeliveryTimeHint(state, <string>value.row["U_COR_LI_1"], false)
}

const HookField_U_COR_LI_1_GetEditHint: SYSAction<
  HookFieldGetEditHint_Type,
  HookFieldGetEditHint_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  if (FieldIsValid(value.field)) {
    return GetDeliveryTimeHint(state, <string>value.row["U_COR_LI_1"], true).res
  }
}

const HookField_DocEntry_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  const handleClick = async (e: Event, rowKey: any) => {
    e.preventDefault()
    e.stopPropagation()
    await GotoDetailHelper(rowKey)
  }
  let row = <Offering>value.row
  return {
    res: CanDetailHelper(row)
      ? html`${row.DocEntry}`
      : // prettier-ignore
        html`<div><span class="offeringdocnumlink"><a class="fd-link" id="odnl${value.rowKey}" href="" @click=${(e) => handleClick(e, value.rowKey)}>${row.DocEntry}</a></span></div>`,
    valueRaw: row.DocEntry,
  }
}

const HookField_DocTotal_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let status = <OfferingStatus>value.row["U_ITF_PRT_OfferStatus"]
  let error = value.row["U_ITF_PRT_OfferError"]
  let docTotal = <number>value.row["DocTotal"]
  if (!error && status !== "Accepted" && status !== "Ready") {
    // prettier-ignore
    return {
      res: html`<div class="fd-busy-indicator--s" aria-hidden="false" aria-label="Loading"><div class="fd-busy-indicator--circle-0"></div><div class="fd-busy-indicator--circle-1"></div><div class="fd-busy-indicator--circle-2"></div></div>`,
      useDefault: false,
    }
  } else if (
    error ||
    state.app.features.QUTOffering.detailsChanged === value.rowKey
  ) {
    return { res: "---", useDefault: false }
  }
  return { res: N0(docTotal), useDefault: false }
}
const HookViewRowClass: SYSAction<
  HookViewRowClass_Type,
  Promise<HookViewRowClass_ReturnType>
> = async (value, { global }) => {
  let state = global.getState()
  let actions = global.getActions()
  let res: HookViewRowClass_ReturnType = { className: undefined }
  let row = value.tableData.data[value.rowKey]
  let status: OfferingStatus = row["U_ITF_PRT_OfferStatus"]
  if (row["U_ITF_PRT_OfferError"]) {
    let noPartsErr = "NoPartsFound"
    let errorMsg = row["U_ITF_PRT_OfferError"].toString()
    if (errorMsg.indexOf(noPartsErr) > -1) {
      errorMsg = T(`QUTOfferingOfferingError${noPartsErr}`)
    }
    res = {
      className: "offering-row-error",
      tooltip: `${errorMsg}, Status: ${T(
        `QUTOfferingOfferingStatus${status}`
      )}`,
    }
  } else if (status !== "Ready" && status !== "Accepted") {
    res = {
      className: "offering-row-inprogress",
      tooltip: "",
    }
  }
  if (
    row["U_ITF_PRT_OfferByAdmin"] === "Y" &&
    row["U_ITF_PRT_OfferType"] !== "Actual"
  ) {
    if (res) {
      res.className = `${res.className} offering-row-isfromadmin`
    } else {
      res = { className: "offering-row-isfromadmin", tooltip: "" }
    }
  }
  if (ScreenCurrent() === "QUTOfferingAdmin") {
    res.draggable = true
  }

  return Promise.resolve(res)
}

export const GotoDetailHelper = async (rowKey: string) => {
  if (
    ovl.getState().app.features.QUTOffering.selectedOfferKey !== undefined &&
    ovl.getState().app.features.QUTOffering.selectedOfferKey !== rowKey &&
    ovl.getState().app.features.QUTOffering.detailsChanged
  ) {
    if (
      (await DialogOkCancel(
        "Wollen Sie die Änderungen in den anderen Details verwerfen?"
      )) !== 1
    ) {
      return
    } else {
      ResetDetailChanges()
    }
  }
  ovl.getState().app.features.QUTOffering.imageLoaded = ""

  await ScreenNavigateTo("QUTOfferingDetails", {
    instance: rowKey,
  })
}

const HookTableRowFn: SYSAction<HookTableRowFn_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  let actions = global.getActions()
  switch (value.fnKey) {
    case "Resume":
      let status = value.data.data[value.rowKey]["U_ITF_PRT_OfferStatus"]
      if (status === "Init") {
        if (ScreenCurrent() === "QUTOfferingAdmin") {
          state.app.features.QUTOffering.adminResumeDocEntry =
            value.row["DocEntry"]
          await OpenTableUploadEdit()
        } else {
          BrowseOfferFile()
        }
        return
      }
      if ((await DialogOkCancel(T("QUTOfferingOfferingResume"))) === 1) {
        let row: Offering = value.data.data[value.rowKey]
        let docEntry = row.DocEntry
        let status = row.U_ITF_PRT_OfferStatus

        if (value.rowKey === state.app.features.QUTOffering.selectedOfferKey) {
          ResetDetailChanges()
        }

        try {
          Data(
            "offering/resume",
            {
              docEntry,
              status,
            },
            { method: "GET" }
          )
          setTimeout(() => {
            actions.app.features.QUTOffering.actions.ShowOfferingProgress({
              docEntry,
              clearError: true,
            })
          }, 500)
        } finally {
        }
      }

    case "GotoDetail":
      await GotoDetailHelper(value.rowKey)
      break
    case "AdminCutOfferPurchaseExport":
      await FileGet({
        cat: "OfferingPosPurchaseOrderTemplate",
        id1: value.row.DocEntry,
      })
      break
    case "AdminCutOfferExport":
      let docEntry = value.row.DocEntry
      try {
        ProcessStart("QUTOfferingPosProductionExport", { instance: docEntry })
        await Data("offeringpos/productionexport", docEntry)
      } finally {
        ProcessEnd("QUTOfferingPosProductionExport", docEntry)
      }

      break

    case "EmailNotification":
      let row: Offering =
        state.app.global.QUT.tables.QUTOffering.data[value.rowKey]
      ProcessStart("QUTOfferingOfferingEmailNotification", {
        snack: {
          type: "BusyIndicator",
          text: row.U_ITF_PRT_OfferEmailInfo
            ? T("QUTOfferingOfferingEmailNotificationOff")
            : T("QUTOfferingOfferingEmailNotificationOn"),
        },
      })
      try {
        await TableSaveRow("QUTOffering", {
          DocEntry: row.DocEntry,
          U_ITF_PRT_OfferEmailInfo: row.U_ITF_PRT_OfferEmailInfo
            ? ""
            : `Subject: ${row.Comments}, ErrorSent: false`,
        })
      } finally {
        ProcessEnd("QUTOfferingOfferingEmailNotification")
      }

      break
  }
}

const HookTableRowFnCan: SYSAction<HookTableRowFnCan_Type> = async (
  value,
  { global }
) => {
  let row: Offering = value.tableData.data[value.rowKey]
  let set = value.set
  set("Resume", { visibility: "NotVisible" })
  if (row["U_ITF_PRT_OfferError"] && !EditLocked()) {
    set("Resume", {
      visibility: "Visible",
      tooltip: T("QUTOfferingOfferingResume"),
    })
  }
  if (
    !FeatureInfo("QUTOfferingToolAdmin") &&
    row.U_ITF_PRT_OfferStatus === <OfferingStatus>"Accepted"
  ) {
    set("SYSEdit", { visibility: "Disabled" })
  }
  if (
    !FeatureInfo("QUTOfferingToolAdmin") ||
    row.U_ITF_PRT_OfferMainType !== "CUT"
  ) {
    set(["AdminCutOfferExport", "AdminCutOfferPurchaseExport"], {
      visibility: "NotVisible",
    })
  } else {
    if (
      ProcessIsRunning("QUTOfferingPosProductionExport") ||
      ProcessIsRunning("SYSFileGet") ||
      row["U_ITF_PRT_OfferError"] ||
      EditLocked()
    ) {
      set(["AdminCutOfferExport", "AdminCutOfferPurchaseExport"], {
        visibility: "Disabled",
      })
    }
  }

  if (CanDetailHelper(row)) {
    set("GotoDetail", {
      visibility: "Disabled",
      tooltip: T("QUTOfferingOfferNotReady"),
    })
  }
  if (
    !FeatureInfo("QUTOfferingToolAdmin") &&
    row.U_ITF_PRT_OfferStatus === <OfferingStatus>"Accepted"
  ) {
    set("SYSDelete", { visibility: "NotVisible", tooltip: "" })
  }

  if (row["U_ITF_PRT_OfferEmailInfo"]) {
    set("EmailNotification", {
      visibility: "Visible",
      icon: "sap-icon--email-read",
      tooltip: T("QUTOfferingOfferingEmailNotificationOff"),
    })
  } else {
    set("EmailNotification", {
      visibility: "Visible",
      icon: "sap-icon--email",
      tooltip: T("QUTOfferingOfferingEmailNotificationOn"),
    })
  }
  if (
    FeatureInfo("QUTOfferingToolAdmin") ||
    ProcessIsRunning("QUTOfferingOfferingEmailNotification")
  ) {
    set("EmailNotification", { visibility: "Disabled" })
  }
}

const CanDetailHelper = (row: Offering) => {
  return (
    row["U_ITF_PRT_OfferError"] ||
    (<OfferingStatus>row["U_ITF_PRT_OfferStatus"] !== "Accepted" &&
      <OfferingStatus>row["U_ITF_PRT_OfferStatus"] !== "Ready")
  )
}

const HookTableAfterDelete: SYSAction<HookTableAfterDelete_Type> = async (
  value,
  { global }
) => {
  let state = global.getState()
  if (value.key === state.app.features.QUTOffering.selectedOfferKey) {
    ResetDetailChanges()
  }
}

export let hooks = {
  HookTableDragDrop,
  HookTableSetColumnVisibility,
  HookFormInit,
  HookField_U_COR_LI_1_GetList,
  HookField_U_COR_LI_1_GetValueRender,
  HookField_U_COR_LI_1_GetEditHint,
  HookField_DocEntry_GetValueRender,
  HookField_DocTotal_GetValueRender,
  HookViewRowClass,
  HookTableRowFnCan,
  HookTableAfterDelete,
  HookTableAfterSave,
  HookTableRowFn,
  HookField_U_ITF_PRT_OfferType_GetList,
}
